$(document).ready(function () {
  // Select all elements with class "elementWithClass"
  const elementsWithClass = $(".left-text-title");

  elementsWithClass.each(function () {
    // Check if the current element has the class "elementWithClass"
    if ($(this).hasClass("lefttext")) {
      // Add the class "newClass" to the parent div
      $(this).parent().parent().addClass("advantages-uses-add");
    }
  });
});


$(document).ready(function () {
$(".dropdown-toggle-two").click(function(){
  $(".dropdown-menu-two").toggleClass("langopen");
});

$(".dropdown-toggle-one").click(function(){
  $(".dropdown-menu-one").toggleClass("langopen");
});
  
});  


$(document).ready(function () {
  if ($(window).width() < 1024) {
  $(".navmenu-depth-3 .navmenu-link").click(function(event) {                
                event.preventDefault();
                var href = $(this).attr("href");
               window.location.href = href;
     setTimeout(function() {
                    window.location.reload();
                }, 500); 
            });
    }
});  

window.addEventListener('scroll', function () {
  const triggerEl = document.querySelector('.bcontact-field__html');
  const otherEl = document.querySelector('.application-title'); // Replace with actual selector
  const targetEl = document.querySelector('.bcontact-field.bcontact-field--image-choice');
  const targetE2 = document.querySelector('.bcontact-field__Select-The-Tool-Style');

  // Check all required elements exist
  if (!triggerEl || !otherEl || !targetEl || !targetE2) return;

  const triggerOffset = triggerEl.getBoundingClientRect().top;
  const otherOffset = otherEl.getBoundingClientRect().top;

  if (triggerOffset <= 150 && otherOffset > 150) {
    targetEl.classList.add('sticky');
    targetE2.classList.add('sticky');
  } else {
    targetEl.classList.remove('sticky');
    targetE2.classList.remove('sticky');
  }
}); 

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a.navmenu-link').forEach(link => {
    if (link.textContent.trim() === 'Brochure sur les lames industrielles') {
      link.href = 'https://cdn.shopify.com/s/files/1/1125/8934/files/Baucor-Industrial_Blades_070b47fd-7c3f-49b0-8ab4-3a6612609a2d.pdf?v=1766135582';
    }
    if (link.textContent.trim() === 'Brochure sur les outils CNC') {
      link.href = 'https://cdn.shopify.com/s/files/1/1125/8934/files/Baucor-Cnc_tools_bf272585-ede8-4467-80c0-c758f4831fd2.pdf?v=1766135585';
    }
  });
});


$(document).ready(function(){
  $(".table-content-title").click(function(){
    $(".table-content-menu").toggle();
  });
  $(".table-content-menu a").click(function(){
    $(".table-content-menu").hide();
  });
});



document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".table-content-menu a").forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      console.log("clicked:", this); // ✅ check if firing

      const targetId = this.getAttribute("href").substring(1);
      const block = document.getElementById(targetId);

      if (block) {
        const extraOffset = 50;
        const header = document.querySelector("header");
        const headerHeight = header ? header.offsetHeight : 0;

        const elementTop = block.getBoundingClientRect().top + window.scrollY;
        const scrollTo = elementTop - headerHeight - extraOffset;        

        window.scrollTo({
          top: scrollTo,
          behavior: "smooth"
        });
      }

      history.pushState(null, "", " ");
    });
  });
});